import { Pipe, PipeTransform } from '@angular/core';

/**
 * Generated class for the NotificationsPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'notifications',
})
export class NotificationsPipe implements PipeTransform {
  transform(values: any, filter: boolean) {
    return values.filter(x => x.archived === filter);
  }
}



// WEBPACK FOOTER //
// ./src/pipes/notifications/notifications.ts